import { useCount } from "@/global-state/global.state";
import { commons } from "@/services/requests";
import {
  IBrandsGeneric,
  IPagination,
  IProduct,
  IProductDataGeneric,
} from "global-types/global.types";
import { SetStateAction } from "react";
import { useQuery } from "react-query";

interface Props {
  initialData: IProduct<IProductDataGeneric<IBrandsGeneric>[], IPagination>;
  params: any;
  setPaginationData: (
    params: SetStateAction<IProductDataGeneric<IBrandsGeneric>[]>
  ) => void;
}

export default function useProduct({
  initialData,
  params,
  setPaginationData,
}: Props) {
  const { count } = useCount();

  const { data, isLoading, isFetching } = useQuery(
    ["PRODUCT", params.category, params],
    commons.getProducts,
    {
      initialData,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      onSuccess: (data) => {
        if (count === 1) {
          setPaginationData(data.data);
        } else {
          setPaginationData((prev) => [...prev, ...data.data]);
        }
      },
    }
  );

  return { data, isLoading, isFetching };

}
